// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__IFgHR","topBottomGutter":"Layout_topBottomGutter__27Djo"};